import React from 'react'

export const InputField = (props) => {
  return (
    <div>
        <input type={props.type} className={props.className} placeholder={props.placeholder} disabled={props.disabled}
        value={props.value}
        onChange={props.onChange} name={props.name}/>
    </div>
  )
}
